import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';

function ErrorPage() {
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message');

  const getErrorMessage = () => {
    if (message === 'no_groups') {
      return {
        title: 'Accesso Negato',
        description: 'Non hai gruppi Azure abilitati per accedere a questa applicazione. Contatta l\'amministratore per richiedere l\'accesso.'
      };
    }
    if (message === 'rebelnet_unavailable') {
      return {
        title: 'Servizio non disponibile',
        description: 'Il servizio Rebel Net non è raggiungibile in questo momento. Riprova tra qualche minuto; se il problema persiste contatta l\'assistenza.'
      };
    }
    return {
      title: 'Errore',
      description: 'Si è verificato un errore durante l\'autenticazione.'
    };
  };

  const error = getErrorMessage();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <ErrorIcon sx={{ fontSize: 80, color: '#f44336', mb: 3 }} />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
          {error.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {error.description}
        </Typography>
        <Button
          variant="contained"
          onClick={() => window.close()}
          sx={{
            backgroundColor: '#3F47F5',
            '&:hover': { backgroundColor: '#2E35C1' }
          }}
        >
          Chiudi
        </Button>
      </Box>
    </Container>
  );
}

export default ErrorPage;
